import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useReveal } from "@/hooks/useReveal";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ServicesMarquee } from "@/components/ServicesMarquee";
import { Services } from "@/components/Services";
import { Work } from "@/components/Work";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { QuoteForm } from "@/components/QuoteForm";
import { MapHours } from "@/components/MapHours";
import { Footer } from "@/components/Footer";
import AboutPage from "@/pages/AboutPage";
import CareersPage from "@/pages/CareersPage";

const Home = () => {
  const ref = useReveal();

  return (
    <main ref={ref}>
      <Hero />
      <ServicesMarquee />
      <Services />
      <Work />
      <BeforeAfter />
      <Reviews />
      <About />
      <QuoteForm />
      <MapHours />
    </main>
  );
};

function App() {
  return (
    <div className="App bg-[#faf8f5] text-[#1f281e] antialiased">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
